export default __webpack_public_path__ + "static/media/ViewInTable.4183df9b.svg";